export const CHUNK_RELOAD_KEY = 'meridian:chunk-reload-at';
const RELOAD_GUARD_MS = 60_000;

function claimReload(now: number): boolean {
  try {
    const last = Number(window.sessionStorage.getItem(CHUNK_RELOAD_KEY));
    if (now - last < RELOAD_GUARD_MS) return false;
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
    return true;
  } catch {
    return false;
  }
}

// A deploy between loading the page and lazy-loading a route leaves the open tab asking for
// chunk URLs the new index no longer references. One reload picks up the new index; the guard
// keeps a genuinely broken build from reloading forever.
export function installChunkReloadRecovery(reload: () => void = () => window.location.reload()): () => void {
  const onPreloadError = (event: Event) => {
    if (!claimReload(Date.now())) return;
    event.preventDefault();
    reload();
  };
  window.addEventListener('vite:preloadError', onPreloadError);
  return () => window.removeEventListener('vite:preloadError', onPreloadError);
}
